import { DynamicsAdapter } from 'app/model/adapters/dataflow/formatAdapters/dynamics.adapter';
import { DataFlowDSLAdapterRegistry, Metamodel, Owned } from 'shell-models-lib';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';
import { DataverseSettings } from 'app/model/dataflow/dataset-settings/dataverse-settings';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(DataverseSettings)
})
export class DataverseAdapter extends DynamicsAdapter {
    protected _generateSetting(owner: DataFlowSource | DataFlowSink): DataverseSettings {
        const setting = Owned.create<DataverseSettings>(DataverseSettings.MODEL, owner);
        setting.initialize(undefined);
        return setting;
    }
}
